import React from 'react';
import { useNavigate  } from 'react-router-dom'; // Используем для навигации между страницами
import './Header.css'; // Подключаем стили

import treeIcon from '../icons/tree.svg';
import settingsIcon from '../icons/settings.svg';

const Header = () => {
  const navigate = useNavigate ();

  return (
    <header className="header">
    <div className="header-left">
      <h1>MAS-IOT</h1>
    </div>
    <div className="header-right">
      <img
        src={treeIcon}
        alt="Tree"
        className="icon"
        onClick={() => navigate('/')}
      />
      <img
        src={settingsIcon}
        alt="Settings"
        className="icon"
        onClick={() => navigate('/settings')}
      />
    </div>
  </header>
);
};


export default Header;
